import { getField, updateField } from 'vuex-map-fields';
import NextAvailable from '../../api/next-available';

// initial state
const state = {
    nextAvailableAppointment: null,
    clinicUrl: null
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getInformation({ commit, rootState }, { clinicId, dealerId, clientToken, cb }) {
        NextAvailable.getInformation((data) => {
            const clinic = Array.isArray(data?.data) ? data.data[0] ?? null : null;

            commit('setStateValue', { key: 'nextAvailableAppointment', value: clinic?.nextAvailableAppointment });
            commit('setStateValue', { key: 'clinicUrl', value: clinic?.clinicUrl });
            if (cb) {
                cb();
            }
        }, { clinicId, dealerId, clientToken });
    },
    
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
